export default __webpack_public_path__ + "static/media/thiio_logo.7edbede8.png";